/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
import './db/db'

import "./plugins/index";

import CardLoadingTransparent from "./components/shared/CardLoadingTransparent";
import CardLoading from "./components/shared/CardLoading";
import DialogLoading from "./components/shared/DialogLoading";
Vue.component("dialog-loading", DialogLoading);
Vue.component("card-loading", CardLoading);
Vue.component("card-loading-transparent", CardLoadingTransparent);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
/* eslint-enable */
